import { useDealership } from '../../store/zustand/dealershipStore'
import { UseQueryResult, useQuery } from 'react-query'
import request from '../request'
import { Vendor } from '../../lib/types/Vendor'

export const useGetLinkedAccounts = (): UseQueryResult<Array<Vendor>, Error> => {
  const dealership = useDealership()

  return useQuery([dealership?.organization_id, 'linked-accounts'], () =>
    request<{ data: Array<Vendor> }>({
      url: `/agencies/${dealership?.organization_id}/linked-accounts/`,
      method: 'GET',
    }).then((res: { data: Array<Vendor> }) => res.data),
  )
}
